import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-page">

      {/* HERO */}
      <div className="about-hero">
        <h1>About E-Advisors Solution</h1>
        <p>
          Your Trusted Partner for Business Registration,
          Compliance, Legal, Financial, and Growth Solutions.
        </p>
      </div>

      <div className="about-content">

        {/* INTRODUCTION */}
        <div className="about-section">
          <h2>Who We Are</h2>

          <p>
            E-Advisors Solution is a leading online business consultancy
            platform dedicated to helping startups, entrepreneurs,
            MSMEs, professionals, and growing enterprises across India.
          </p>

          <p>
            We simplify complex registration, compliance, legal, and
            financial procedures by providing professional guidance and
            end-to-end support through a single digital platform.
          </p>

          <p>
            Our mission is to make business setup and compliance services
            accessible, affordable, transparent, and hassle-free for
            businesses of every size.
          </p>
        </div>

        {/* SERVICES */}
        <div className="about-section">
          <h2>Our Services</h2>

          <div className="service-grid-about">

            <div className="service-card-about">
              <h3>Company Registration</h3>
              <p>
                Private Limited Company, LLP, OPC, Partnership Firm,
                and Startup Registration.
              </p>
            </div>

            <div className="service-card-about">
              <h3>GST Services</h3>
              <p>
                GST Registration, GST Return Filing, GST Compliance,
                and GST Advisory Services.
              </p>
            </div>

            <div className="service-card-about">
              <h3>Trademark & IP Protection</h3>
              <p>
                Trademark Registration, Copyright Registration,
                Patent Assistance, and Brand Protection Services.
              </p>
            </div>

            <div className="service-card-about">
              <h3>FSSAI Registration</h3>
              <p>
                Food License Registration and Regulatory Compliance
                Assistance.
              </p>
            </div>

            <div className="service-card-about">
              <h3>Import Export Code (IEC)</h3>
              <p>
                IEC Registration and International Trade Compliance
                Support.
              </p>
            </div>

            <div className="service-card-about">
              <h3>ISO Certification</h3>
              <p>
                ISO Certification Consultancy and Documentation Support.
              </p>
            </div>

            <div className="service-card-about">
              <h3>Business Planning</h3>
              <p>
                Business Plans, Project Reports, Startup Guidance,
                and Growth Strategies.
              </p>
            </div>

            <div className="service-card-about">
              <h3>Legal & Financial Consultancy</h3>
              <p>
                Professional assistance for MSMEs, startups,
                and established businesses.
              </p>
            </div>

          </div>
        </div>

        {/* WHY CHOOSE */}
        <div className="about-section">
          <h2>Why Choose E-Advisors Solution?</h2>

          <ul className="about-list">
            <li>✔ Expert Professional Guidance</li>
            <li>✔ Transparent Process & Pricing</li>
            <li>✔ End-to-End Service Support</li>
            <li>✔ Fast Documentation Assistance</li>
            <li>✔ Secure Data Handling & Confidentiality</li>
            <li>✔ Dedicated Customer Support</li>
            <li>✔ Affordable Solutions for Startups & MSMEs</li>
            <li>✔ Compliance-Focused Service Delivery</li>
          </ul>
        </div>

        {/* MISSION */}
        <div className="about-section">
          <h2>Our Mission</h2>

          <p>
            To empower entrepreneurs, startups, and businesses by
            providing reliable, efficient, and technology-driven
            business solutions that support long-term growth and
            regulatory compliance.
          </p>
        </div>

        {/* VISION */}
        <div className="about-section">
          <h2>Our Vision</h2>

          <p>
            To become one of India's most trusted and preferred
            business consultancy platforms by delivering quality,
            transparency, professionalism, and innovation in every
            service we provide.
          </p>
        </div>

        {/* VALUES */}
        <div className="about-section">
          <h2>Our Core Values</h2>

          <div className="value-grid">

            <div className="value-card">
              <h3>Integrity</h3>
              <p>
                We operate with honesty, ethics, and accountability.
              </p>
            </div>

            <div className="value-card">
              <h3>Transparency</h3>
              <p>
                Clear communication and no hidden commitments.
              </p>
            </div>

            <div className="value-card">
              <h3>Confidentiality</h3>
              <p>
                Complete protection of client information and data.
              </p>
            </div>

            <div className="value-card">
              <h3>Excellence</h3>
              <p>
                Delivering high-quality services with professionalism.
              </p>
            </div>

          </div>
        </div>

        {/* CONTACT */}
        <div className="about-contact">
          <h2>Contact Us</h2>

          <p>
            Have questions or need assistance? Our team is ready to help.
          </p>

          <a
            href="https://e-advisorssolution.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit Our Website
          </a>

          <p className="contact-email">
            Email: info@e-advisorssolution.com
          </p>
        </div>

      </div>
    </div>
  );
};

export default About;